import type { Route } from "./+types/signin-route";
import SignIn from "./components/Signin";
import { generateSeoMeta } from "~/common/utils/seo-meta";

export function meta({}: Route.MetaArgs) {
  return generateSeoMeta({
    title: "Увійти",
    description:
      "Увійдіть до свого облікового запису Brandly для контролю торгових марок та відстеження статусів заявок.",
    noindex: true, // Auth pages typically shouldn't be indexed
  });
}

export default function SigninRoute() {
  return <SignIn />;
}
